import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
// import { AppState } from '@capacitor/app';
import { setLoadingSpinner } from '../actions/shared.action';
import { catchError, exhaustMap, filter, map, mergeMap, of, tap, withLatestFrom } from 'rxjs';
import { ROUTER_NAVIGATION, RouterNavigatedAction } from '@ngrx/router-store';
import * as fromAccountActions from '././../actions/account.action'
import { APIResponse } from 'src/app/models/api-response.model';
import { AccountService } from 'src/app/services/account.service';
import { OfflineStorageService } from 'src/app/services/offline-storage.service';
import { AppState } from '../app.state';
import { ModalService } from 'src/app/services/modal.service';
import { Router } from '@angular/router';
import { getUserProfile } from '../selectors/account.selector';
import { AuthService } from 'src/app/services/auth.service';
import { getDatabaseList } from '../actions/database.action';

@Injectable()
export class AccountEffects {

  userProfile$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ROUTER_NAVIGATION),
      filter((r : RouterNavigatedAction) => {
        return r.payload.routerState.url.startsWith('/home/dashboard');
      }),
      exhaustMap((action) =>
        this.accountService.userProfile().pipe(
          map((response) => { 
            return fromAccountActions.getUserProfileSuccess({ data: response?.details});
          }),
          catchError((response) => {
            return of(fromAccountActions.getUserProfileFailed({ data: response.error }));
          })
        )
      )
    )
  },
  { dispatch: false });

  getUserProfile$ = createEffect(
    ()=> this.actions$.pipe(
      ofType(fromAccountActions.getUserProfile),
      exhaustMap((action) => 
        this.accountService.userProfile().pipe(
          map((response)=>{
            this.store.dispatch(setLoadingSpinner({status : false}));
            return fromAccountActions.getUserProfileSuccess({data: response?.details})
          }),
          catchError((response)=>{
            this.store.dispatch(setLoadingSpinner({status : false}));
            return of(fromAccountActions.getUserProfileFailed({data : response?.error?.message}))
          })
        )
      )
    )
  );
  
  getUserProfileSuccess$ = createEffect(
    ()=> this.actions$.pipe(
        ofType(fromAccountActions.getUserProfileSuccess),
        tap(async (action) =>{
          await this.offlineStorageService.setObject('user', JSON.stringify(action.data));
          this.router.navigate(['/home/queue']);
          // if(action.data?.userType !== 'employee'){
          //   console.log("getUserProfileSuccess$", action.data);
          //   this.store.dispatch(fromAccountActions.getStudentApplication({redirect: true}));
          // } else{
          //   this.router.navigate(['/home/dashboard']);
          //   this.store.dispatch(setLoadingSpinner({status : false}));
          // }
        })
      ),
    { dispatch: false }
  );

  getUserProfileFailed$ = createEffect(
    ()=> this.actions$.pipe(
        ofType(fromAccountActions.getUserProfileFailed),
        tap(async (action) =>{
          console.log("getUserProfileFailed$", action.data);
          // if(action.data){
          //   const message = action.data;
          //   this.modalService.errorModal(message)
          // } else{
          //   const message = 'Unkown error ocurred. Please try again later.'
          //   this.modalService.errorModal(message)
          // }
        })
      ),
    { dispatch: false }
  );
  
  getApplicantDetails$ = createEffect(
    ()=> this.actions$.pipe(
      ofType(fromAccountActions.getApplicantDetails),
      exhaustMap((action) => 
        this.accountService.getApplicantDetails(action.uuid).pipe(
          map((response)=>{
            this.store.dispatch(setLoadingSpinner({status : false}));
            return fromAccountActions.getApplicantDetailsSuccess({data: response?.details, redirect: action?.redirect, tranType: action?.tranType})
          }),
          catchError((response)=>{
            this.store.dispatch(setLoadingSpinner({status : false}));
            return of(fromAccountActions.getApplicantDetailsFailed({data : response?.error?.message}))
          })
        )
      )
    )
  );
  
  getApplicantDetailsSuccess$ = createEffect(
    ()=> this.actions$.pipe(
        ofType(fromAccountActions.getApplicantDetailsSuccess),
        tap(async (action) =>{
          if(action?.redirect){
            if(action?.tranType == 'view'){
              this.router.navigateByUrl('/home/applicant-details');
            } else{
              this.router.navigateByUrl('/home/upload-documents');
            }
          }
        })
      ),
    { dispatch: false }
  );

  getApplicantDetailsFailed$ = createEffect(
    ()=> this.actions$.pipe(
        ofType(fromAccountActions.getApplicantDetailsFailed),
        tap(async (action) =>{
          console.log("getApplicantDetailsFailed$", action.data);
          if(action.data){
            const message = action.data;
            this.modalService.errorModal(message)
          } else{
            const message = 'Unkown error ocurred. Please try again later.'
            this.modalService.errorModal(message)
          }
        })
      ),
    { dispatch: false }
  );

  verifyApplication$ = createEffect(
    ()=> this.actions$.pipe(
      ofType(fromAccountActions.verifyApplication),
      exhaustMap((action) => 
        this.accountService.verifyApplication(action.uuid).pipe(
          map((response)=>{
            this.store.dispatch(setLoadingSpinner({status : false}));
            return fromAccountActions.verifyApplicationSuccess({data: response?.details})
          }),
          catchError((response)=>{
            this.store.dispatch(setLoadingSpinner({status : false}));
            return of(fromAccountActions.verifyApplicationFailed({data : response?.error?.message}))
          })
        )
      )
    )
  );

  verifyApplicationSuccess$ = createEffect(
    ()=> this.actions$.pipe(
        ofType(fromAccountActions.verifyApplicationSuccess),
        tap(async (action) =>{
          this.router.navigateByUrl('/home/queue');
          this.modalService.hideVerifyMaster();
        })
      ),
    { dispatch: false }
  );

  verifyApplicationFailed$ = createEffect(
    ()=> this.actions$.pipe(
        ofType(fromAccountActions.verifyApplicationFailed),
        tap(async (action) =>{
          console.log("verifyApplicationFailed$", action.data);
          if(action.data){
            const message = action.data;
            this.modalService.errorModal(message)
          } else{
            const message = 'Unkown error ocurred. Please try again later.'
            this.modalService.errorModal(message)
          }
        })
      ),
    { dispatch: false }
  );

  transmitApplication$ = createEffect(
    ()=> this.actions$.pipe(
      ofType(fromAccountActions.transmitApplication),
      exhaustMap((action) => 
        this.accountService.transmitApplication(action.uuid).pipe(
          map((response)=>{
            this.store.dispatch(setLoadingSpinner({status : false}));
            return fromAccountActions.transmitApplicationSuccess({data: response?.details})
          }),
          catchError((response)=>{
            this.store.dispatch(setLoadingSpinner({status : false}));
            return of(fromAccountActions.transmitApplicationFailed({data : response?.error?.message}))
          })
        )
      )
    )
  );

  transmitApplicationSuccess$ = createEffect(
    ()=> this.actions$.pipe(
        ofType(fromAccountActions.transmitApplicationSuccess),
        tap(async (action) =>{
          this.store.dispatch(getDatabaseList());
          this.modalService.hideConfirmTransmit();
        })
      ),
    { dispatch: false }
  );

  transmitApplicationFailed$ = createEffect(
    ()=> this.actions$.pipe(
        ofType(fromAccountActions.transmitApplicationFailed),
        tap(async (action) =>{
          console.log("transmitApplicationFailed$", action.data);
          if(action.data){
            const message = action.data;
            this.modalService.errorModal(message)
          } else{
            const message = 'Unkown error ocurred. Please try again later.'
            this.modalService.errorModal(message)
          }
        })
      ),
    { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private accountService: AccountService,
    private offlineStorageService: OfflineStorageService,
    private store: Store<AppState>,
    private modalService: ModalService,
    private router: Router,
    private authService: AuthService
  ) {}

}
